import React from "react";
import { FiLogOut } from "react-icons/fi";

const AdminHeader = ({ onLogout }) => {
  return (
    <header className="admin-header">
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <div>
          <h1 className="admin-header-title">
            MUJ Convocation Admin Portal
          </h1>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <button
          onClick={onLogout}
          style={{
            backgroundColor: "#ef4444",
            color: "#fff",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "background 0.2s",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <FiLogOut /> Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
